var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bonus-send-record-pane" },
    [
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("phone-user-select", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "请输入手机号" },
                    on: { select: _vm.handlePhoneUserSelect },
                    model: {
                      value: _vm.searchForm.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "userId", $$v)
                      },
                      expression: "searchForm.userId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "请选择发放状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.sendStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "sendStatus", $$v)
                        },
                        expression: "searchForm.sendStatus",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "已发放", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "待发放", value: 0 } }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "发放失败", value: 2 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.searchForm.dateRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "dateRange", $$v)
                      },
                      expression: "searchForm.dateRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [
                      _c("i", { staticClass: "el-icon-search" }),
                      _vm._v("\n          查询\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _c("i", { staticClass: "el-icon-refresh-left" }),
                    _vm._v("\n          重置\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", loading: _vm.exportLoading },
                      on: { click: _vm.handleExport },
                    },
                    [
                      _c("i", { staticClass: "el-icon-download" }),
                      _vm._v("\n          导出\n        "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-area" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  align: "center",
                  width: "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "用户信息",
                  align: "left",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "user-info-wrapper" },
                          [
                            _c("el-avatar", {
                              staticClass: "user-avatar",
                              attrs: {
                                src: _vm.getAvatarUrl(scope.row.userpic),
                                size: 50,
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-detail" }, [
                              _c("div", { staticClass: "user-name" }, [
                                _vm._v(_vm._s(scope.row.alias || "-")),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "user-mobile" }, [
                                _vm._v(_vm._s(scope.row.mobilePhone || "-")),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-rank" },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm.getUserRankTagType(
                                          scope.row.userRank
                                        ),
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getUserRankName(
                                              scope.row.userRank
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "发券活动",
                  align: "center",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.bonusSendTitle || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "领取事件", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getEventTagType(scope.row.event),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getEventText(scope.row.event)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "发放明细", align: "left", "min-width": "600" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.items && scope.row.items.length > 0
                          ? _c(
                              "div",
                              { staticClass: "items-list" },
                              _vm._l(scope.row.items, function (item, index) {
                                return _c(
                                  "div",
                                  { key: item.id, staticClass: "item-card" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "item-header" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "item-index" },
                                          [_vm._v(_vm._s(index + 1))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "item-coupon-title" },
                                          [
                                            _vm._v(
                                              _vm._s(item.couponTitle || "-")
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-tag",
                                          {
                                            staticClass: "item-coupon-type",
                                            attrs: {
                                              size: "mini",
                                              type: _vm.getCouponTypeTag(
                                                item.couponType
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getCouponTypeName(
                                                    item.couponType
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "item-body" }, [
                                      _c("div", { staticClass: "item-row" }, [
                                        _c(
                                          "span",
                                          { staticClass: "item-label" },
                                          [_vm._v("别名：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "item-value" },
                                          [
                                            _vm._v(
                                              _vm._s(item.couponAlias || "-")
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "item-row" }, [
                                        _c(
                                          "span",
                                          { staticClass: "item-label" },
                                          [_vm._v("数量：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "item-value" },
                                          [_vm._v(_vm._s(item.sendNum || "-"))]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "item-row" }, [
                                        _c(
                                          "span",
                                          { staticClass: "item-label" },
                                          [_vm._v("优惠券码：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "item-value coupon-code",
                                          },
                                          [_vm._v(_vm._s(item.couponNo || "-"))]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "item-row" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "item-label" },
                                            [_vm._v("发放状态：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: _vm.getSendStatusTagType(
                                                  item.sendStatus
                                                ),
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.getSendStatusText(
                                                      item.sendStatus
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "item-row" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "item-label" },
                                            [_vm._v("核销状态：")]
                                          ),
                                          _vm._v(" "),
                                          item.verificationStatus === 1
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type: "success",
                                                    size: "mini",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    已核销\n                  "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type: "info",
                                                    size: "mini",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    未核销\n                  "
                                                  ),
                                                ]
                                              ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      item.verificationStatus === 1
                                        ? _c(
                                            "div",
                                            { staticClass: "item-row" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "item-label" },
                                                [_vm._v("核销时间：")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "item-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatTime(
                                                        item.verificationTime
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.verificationStatus === 1 &&
                                      item.verificationStoreName
                                        ? _c(
                                            "div",
                                            { staticClass: "item-row" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "item-label" },
                                                [_vm._v("核销门店：")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "item-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.verificationStoreName
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            )
                          : _c("div", { staticClass: "no-items" }, [
                              _vm._v("\n            暂无明细\n          "),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "是否加入企微", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isQwe === 1 || scope.row.isQwe === true
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "small" } },
                              [_vm._v("\n            是\n          ")]
                            )
                          : scope.row.isQwe === 0 || scope.row.isQwe === false
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v("\n            否\n          ")]
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "是否是新用户", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isNewReg === 1 || scope.row.isNewReg === true
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [_vm._v("\n            是\n          ")]
                            )
                          : scope.row.isNewReg === 0 ||
                            scope.row.isNewReg === false
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v("\n            否\n          ")]
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "领取时间",
                  align: "center",
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatTime(scope.row.addTime)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  width: "100",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.hasFailedItems(scope.row)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleResend(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            发放\n          ")]
                            )
                          : _c("span", { staticClass: "no-action" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-area" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "重新发放确认",
            visible: _vm.resendDialogVisible,
            width: "500px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.resendDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "resend-confirm-content" },
            [
              _c("el-icon", {
                staticClass: "el-icon-warning",
                staticStyle: { color: "#E6A23C", "font-size": "48px" },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "confirm-text" }, [
                _vm._v("\n        确定要重新发放吗？\n      "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "confirm-tip" }, [
                _vm._v(
                  "\n        系统只会重新发放失败的明细，已发放成功的明细不会重复发放。\n      "
                ),
              ]),
              _vm._v(" "),
              _vm.currentRecord
                ? _c("div", { staticClass: "failed-items-info" }, [
                    _c("div", { staticClass: "info-title" }, [
                      _vm._v("失败明细数量："),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-count" }, [
                      _vm._v(
                        _vm._s(_vm.getFailedItemsCount(_vm.currentRecord)) +
                          " 条"
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.resendDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.resendLoading },
                  on: { click: _vm.confirmResend },
                },
                [_vm._v("\n        确定发放\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }